import moment from "moment";
export const formatDate = (date, format) =>
  moment(date).format(format) === "Invalid date"
    ? ""
    : moment(date).format(format);
